import type { CreateTransferRequestPayload } from "@/features/transfers/create-transfer-branch-to-branch/types/createTransfer.types";
import type { TransfersHelpData } from "@/features/transfers/types/transfers.types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";


interface TransfersState {
  helperData: TransfersHelpData | null;
  isHelperDataLoaded: boolean;
  draft: CreateTransferRequestPayload | null;
  isDraftLoaded: boolean;
}

const initialState: TransfersState = {
  helperData: null,
  isHelperDataLoaded: false,
  draft: null,
  isDraftLoaded: false,
};

const transfersSlice = createSlice({
  name: "transfers",
  initialState,
  reducers: {
    setHelperData: (state, action: PayloadAction<TransfersHelpData>) => {
      state.helperData = action.payload;
      state.isHelperDataLoaded = true;
    },
    clearHelperData: (state) => {
      state.helperData = null;
      state.isHelperDataLoaded = false;
    },
    setTransferDraft: (state, action: PayloadAction<CreateTransferRequestPayload>) => {
      state.draft = action.payload;
      state.isDraftLoaded = true;
    },
    clearTransferDraft: (state) => {
      state.draft = null;
      state.isDraftLoaded = false;
    },
  },
});

export const { setHelperData, clearHelperData, setTransferDraft, clearTransferDraft } =
  transfersSlice.actions;

export const selectHelperData = (state: { transfers: TransfersState }) =>
  state.transfers.helperData;

export const selectIsHelperDataLoaded = (state: { transfers: TransfersState }) =>
  state.transfers.isHelperDataLoaded;

export const selectTransferDraft = (state: { transfers: TransfersState }) =>
  state.transfers.draft;

export const selectIsTransferDraftLoaded = (state: { transfers: TransfersState }) =>
  state.transfers.isDraftLoaded;

export const transfersReducer = transfersSlice.reducer;
